import Joi from 'joi'

import { Roles } from 'constants/index'
import { phoneNumberOptionalSchema } from 'helpers/phoneValidation.helpers'

const ValidationSchema = Joi.object({
  role: Joi.string().allow('').label('Role'),
  customerId: Joi.when('role', {
    is: Roles.customer,
    then: Joi.string().required(),
    otherwise: Joi.allow('', null),
  }).label('Customer'),
  contactId: Joi.string().allow('').label('Contact'),
  driverId: Joi.allow('', null).optional().label('Driver'),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .allow('')
    .label('Email'),
  userName: Joi.string().allow('').label('Username'),
  firstName: Joi.string().allow('').label('First Name'),
  lastName: Joi.string().allow('').label('Last Name'),
  phoneNumber: phoneNumberOptionalSchema,
  suggestedCompany: Joi.string().allow('').label('Suggested Company'),
})

export default ValidationSchema
